import React from 'react';
import { TextField } from '@material-ui/core';
import styled from 'styled-components';
import HealtheraTable from '../../../../../../components/Table/Table';
import { Organisation } from '../../../../../../types/organisation';
import AddIcon from '@material-ui/icons/Add';

interface SearchOrganisationsProps {
  searchInput: string;
  setSearchInput: (value: string) => void;
  organisations: Organisation[];
  handleAdd: (organisation: Organisation) => void;
  disabled: boolean;
  disabledMessage?: string;
}

const SearchOrganisations: React.FC<SearchOrganisationsProps> = ({
  searchInput,
  setSearchInput,
  organisations,
  handleAdd,
  disabled,
  disabledMessage
}) => {
  const prepareSearchData = (items: Organisation[]) => {
    return [
      {
        view: {
          name: 'Name',
        },
        headers: true
      },
      ...items.map(item => ({
        view: {
          name: item.name,
        },
        button: {
          title: 'Add',
          onClick: () => handleAdd(item),
          icon: <AddIcon />
        }
      }))
    ];
  };

  return (
    <Section>
      <SearchContainer>
        <SearchField
          fullWidth
          label="Search Organisations"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          disabled={disabled}
          helperText={disabled ? disabledMessage : undefined}
        />
      </SearchContainer>

      {!disabled && searchInput.length > 2 && (
        <HealtheraTable
          data={prepareSearchData(organisations)}
          displayPagination={false}
          page={0}
          rowsPerPage={organisations.length}
          rowsPerPageOptions={[]}
          onChangePage={() => {}}
          onRowsPerPageChange={() => {}}
          totalCount={organisations.length}
          isLiveDashboard={false}
          noHover={true}
        />
      )}
    </Section>
  );
};

const Section = styled.div`
  flex: 1;
  width: 50%;
  min-width: 0;
`;

const SearchContainer = styled.div`
  padding-bottom: 24px;
`;

const SearchField = styled(TextField)`
  width: 100%;
`;

export default SearchOrganisations; 
